import { render, staticRenderFns } from "./SearchArticle.vue?vue&type=template&id=406f734c&"
import script from "./SearchArticle.vue?vue&type=script&lang=js&"
export * from "./SearchArticle.vue?vue&type=script&lang=js&"
import style0 from "./SearchArticle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports